import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import httpRequest from "src/helpers/httpRequest";
import { SectionTwoKeys } from "src/types/GlobalInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { canWrite } from "src/helpers/helperFunctions";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
interface IProps {
  data: {
    image: string;
    mainCategory: string;
    _id: string;
    key: SectionTwoKeys;
  }[];
  allCategories: { value: string; label: string }[];
  getLoader: boolean;
}

const TopCategories: React.FC<IProps> = ({
  allCategories = [],
  getLoader = false,
  data = [],
}) => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const hasWriteAccess = canWrite(userDetails, "platformManagement", false);

  const [arr, setArr] = useState<
    { key: SectionTwoKeys; image: string | File; mainCategory: string }[]
  >([
    { key: "categoryOne", image: "", mainCategory: "" },
    { key: "categoryTwo", image: "", mainCategory: "" },
    { key: "categoryThree", image: "", mainCategory: "" },
    { key: "categoryFour", image: "", mainCategory: "" },
    { key: "categoryFive", image: "", mainCategory: "" },
    { key: "categorySix", image: "", mainCategory: "" },
  ]);

  const imageChange = (key: string, image: File | null) => {
    setArr((prev) =>
      prev.map((v) => (v?.key === key ? { ...v, image: image || "" } : v))
    );
  };

  const categoryChange = (key: string, mainCategory: string) => {
    setArr((prev) =>
      prev.map((v) => (v?.key === key ? { ...v, mainCategory } : v))
    );
  };

  const validateForm = (): boolean => {
    const isInvalid = arr.some((v) => !v.image || !v.mainCategory);
    if (isInvalid) {
      toast("All fields are required.", { type: "error" });
      return false; // Form is invalid
    }
    return true; // Form is valid
  };

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const handleSubmit = async () => {
    if (validateForm()) {
      setIsLoader(true);
      const formData = new FormData();
      arr.forEach((item) => {
        formData.append(`${item.key}Image`, item.image);
        formData.append(`${item.key}[mainCategoryId]`, item.mainCategory);
      });
      const { res, err } = await httpRequest<any>({
        method: "put",
        path: "/website-manage/section-two",
        params: formData,
        header: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        toast("Top Categories Updated", { type: "success" });
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (data && data.length) {
      setArr((prev) =>
        prev.map((v) => ({
          ...v,
          image: data.find((i) => i.key === v.key)?.image || "",
          mainCategory: data.find((i) => i.key === v.key)?.mainCategory || "",
        }))
      );
    }
  }, [data]);

  const CheckDuplicates = (tm: string, index: number) => {
    let allData = arr.filter((t, i) => i !== index);
    return allData.some((t) => t.mainCategory === tm);
  };

  return (
    <div className="section__2">
      <h1 className="font-Poppins-SemiBold font-size-25px mb-2 theme-color-green ">
        Section 02
      </h1>
      <div className="products-tabs-content">
        <h3 className="font-size-18px text-[#2F2F31] mb-3 font-Poppins-Regular">
          Top Categories
        </h3>
        <div className="grid grid-cols-3 gap-8 gap-x-10">
          {arr.map((item, ind) => (
            <div className="w-full" key={item.key}>
              <ImageUpload
                newUi={true}
                image={item?.image}
                onImageChange={(file: File | null) =>
                  imageChange(item?.key, file)
                }
                extraClasses={"w-full min-h-[280px] aspect-square"}
                labelId={`top-category-${ind + 1}`}
                disabled={!hasWriteAccess}
              />
              <CustomWebsiteDropdown
                loading={getLoader}
                options={allCategories.map((v) => ({
                  ...v,
                  disabled: CheckDuplicates(v.value, ind),
                }))}
                data={allCategories.filter(
                  (v) => v?.value === item?.mainCategory
                )}
                setData={(e) => categoryChange(item?.key, e[0]?.value || "")}
                placeholder="Select Category"
                dropdownMainId={`top-category-${ind + 1}`}
                disabled={!hasWriteAccess}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end mt-3">
        <PrimaryBtn
          loader={isLoader}
          ButtonText="Save"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={() => {
            if (!hasWriteAccess) {
              return;
            }
            handleSubmit();
          }}
          btnExtralClasses={`${!hasWriteAccess ? "cursor-not-allowed" : ""}`}
          id="top-category-save"
        />
      </div>
    </div>
  );
};

export default TopCategories;
